import { useInstantSearch } from "react-instantsearch";
import { type ReactNode } from "react";
import {useConfigContext} from "../../ConfigProvider.tsx";

interface NoResultsBoundaryProps {
	children: ReactNode;
	fallback: ReactNode;
}

export function NoResultsBoundary({ children, fallback }: NoResultsBoundaryProps) {
	const { results } = useInstantSearch();
	if (!results.__isArtificial && results.nbHits === 0) {
		return (
			<>
				{fallback}
				<div hidden>{children}</div>
			</>
		);
	}
	return children ? <>{children}</> : null;
}

export function NoResults() {
	const { indexUiState } = useInstantSearch();
	const {
		tc,
		algoliaConfig: { isSearch },
	} = useConfigContext();

	return (
		<div className="emptybox">
			{isSearch ? tc.noEntriesFoundForSearch : tc.noEntriesFoundForCategory}
			{isSearch && <q>{indexUiState.query}</q>}
		</div>
	);
}
